export default __webpack_public_path__ + "static/media/imgdefault.e845d602.jpg";